module.exports = __webpack_public_path__ + "img/9.f2c522e2.jpg";